import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Navbar from '../components/site/Navbar';
import Footer from '../components/site/Footer';

const LegalLayout = ({ eyebrow, title, updated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="bg-cream min-h-screen">
      <Navbar />
      <section className="pt-32 pb-14 lg:pt-40">
        <div className="mx-auto max-w-3xl px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[var(--brand-mute)] hover:text-[var(--brand-green)] mb-6">
            <ArrowLeft size={14} /> Back to home
          </Link>
          <div className="text-xs uppercase tracking-[0.24em] text-[var(--brand-gold)] mb-4">{eyebrow}</div>
          <h1 className="font-serif text-4xl lg:text-6xl text-green tracking-tight leading-[1.05]">{title}</h1>
          {updated && (
            <div className="mt-4 text-sm text-[var(--brand-mute)]">Last updated: {updated}</div>
          )}
          <div className="prose prose-lg mt-10 text-[var(--brand-ink)] leading-relaxed [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:text-green [&_h2]:mt-10 [&_h2]:mb-3 [&_p]:mb-4 [&_ul]:list-disc [&_ul]:ml-6 [&_ul]:my-4 [&_li]:mb-2 [&_a]:text-[var(--brand-green)] [&_a]:underline">
            {children}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default LegalLayout;
